import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, ShoppingBag, Package, Tag, Image, LogOut, Store, ScrollText } from "lucide-react";
import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

const baseNav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/coupons", label: "Coupons", icon: Tag },
  { to: "/admin/banners", label: "Banners", icon: Image },
];
const superNav = { to: "/admin/activity", label: "Activity Log", icon: ScrollText };

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) navigate("/login", { state: { from: "/admin" } });
    document.title = "Admin — KKashigari India";
  }, [user, loading]);

  if (loading || !user || user.role !== "admin") return <div className="py-40 text-center uplabel text-[var(--olive)]">Verifying access…</div>;

  const nav = user.is_super ? [...baseNav, superNav] : baseNav;

  return (
    <div className="min-h-screen flex bg-[#FBF7DE]" data-testid="admin-layout">
      <aside className="w-64 shrink-0 border-r border-[var(--line)] bg-[#F3EECB] hidden lg:flex flex-col fixed h-screen">
        <div className="px-6 py-6 border-b border-[var(--line)]"><Logo className="h-10" to="/admin" /></div>
        <nav className="flex-1 px-4 py-6 space-y-1">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${isActive ? "bg-[var(--olive)] text-[#FBF7DE]" : "text-[var(--bronze)] hover:bg-[#FBF7DE]"}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-6 border-t border-[var(--line)] space-y-1">
          <Link to="/" className="flex items-center gap-3 px-4 py-3 text-sm text-[var(--bronze)] hover:bg-[#FBF7DE] transition-colors"><Store className="w-4 h-4" /> View Store</Link>
          <button onClick={() => { logout(); navigate("/"); }} data-testid="admin-logout" className="w-full flex items-center gap-3 px-4 py-3 text-sm text-[var(--bronze)] hover:text-[var(--maroon)] transition-colors"><LogOut className="w-4 h-4" /> Logout</button>
        </div>
      </aside>

      <div className="flex-1 lg:ml-64">
        <div className="lg:hidden flex items-center gap-3 overflow-x-auto hide-scrollbar border-b border-[var(--line)] px-4 py-3 bg-[#F3EECB] sticky top-0 z-40">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `uplabel whitespace-nowrap px-3 py-1.5 ${isActive ? "text-[var(--bronze)]" : "text-[var(--olive)]"}`}>{n.label}</NavLink>
          ))}
          <button onClick={() => { logout(); navigate("/"); }} className="uplabel text-[var(--maroon)] whitespace-nowrap px-3">Logout</button>
        </div>
        <div className="p-5 lg:p-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
